import { noticeConstants } from "../constansts/notice.constants";

const initialState = {
  data: [],
  success: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case noticeConstants.NOTICE_ALL:
      return {
        ...state,
        data: action.data,
        success: true
      };

    default:
      return state;
  }
}
